module.exports = __webpack_public_path__ + "static/media/edit.34ede624.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/edit.svg
// module id = 94
// module chunks = 0